import { render, staticRenderFns } from "./SubscribeCard.vue?vue&type=template&id=627dfefa"
import script from "./SubscribeCard.vue?vue&type=script&lang=js"
export * from "./SubscribeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports